module.exports = __webpack_public_path__ + "static/media/yoga.57261559.jpg";